import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "app-widget"
};
const _hoisted_2 = {
  key: 0,
  class: "widget-item"
};
const _hoisted_3 = {
  key: 1,
  class: "widget-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChatDotSquare = _resolveComponent("ChatDotSquare");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_ShoppingCart = _resolveComponent("ShoppingCart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.showFeedback ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
    class: "item-but",
    type: "primary",
    onClick: $options.handleFeedback
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      size: $options.getIconSize
    }, {
      default: _withCtx(() => [_createVNode(_component_ChatDotSquare)]),
      _: 1
    }, 8, ["size"])]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), $props.showShopping ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
    class: "item-but",
    type: "primary",
    onClick: $options.handleShopping
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      size: $options.getIconSize
    }, {
      default: _withCtx(() => [_createVNode(_component_ShoppingCart)]),
      _: 1
    }, 8, ["size"])]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)]);
}